export const endpoints = {
  jobData: {
    getDeviceLivePositionsForJob: 'job-data/{jobId}/devices/{deviceId}/live-positions',
    getDeviceLogPositionsForJob: 'job-data/{jobId}/devices/{deviceId}/log-positions',
    getDevicesLastLivePositionForJob: 'job-data/{jobId}/devices/last-live-position',
    getDeviceLivePositionsForJobAsFile: 'job-data/{jobId}/devices/{deviceId}/live-positions/as-file/?from={from}&to={to}&trackColor={trackColor}&format={format}&token={token}',
    getDeviceLogPositionsForJobAsFile: 'job-data/{jobId}/devices/{deviceId}/log-positions/as-file/?from={from}&to={to}&trackColor={trackColor}&format={format}&token={token}',
    getDeviceAnalysisSections: 'job-data/{jobId}/device-analysis-sections',
    getDeviceAnalysisSectionData: 'job-data/{jobId}/device-analysis-section-data',
    getDeviceAnalysisSectionDataAsFile: 'job-data/{jobId}/device-analysis-section-data/as-file',
    getAnalysisRendezvous: 'job-data/{jobId}/analysis-rendezvous',
  },
  auth: {
    authenticate: 'auth/token',
    refreshToken: 'auth/refresh-token',
    getJobToken: 'auth/job/{jobId}/token',
    getTemporaryToken: 'auth/temporary-token'
  },
  users: {
    getAll: 'users',
    getIsUsernameAvailable: 'users/username-available/{username}',
    create: 'users',
    resetPassword: 'users/{userId}/reset-password',
    getAllByJobContext: 'users/by-job-context',
    get: 'users/{userId}',
    deactivate: 'users/{userId}/deactivate',
    activate: 'users/{userId}/activate',
    getProfile: 'users/{userId}/profile',
    updateProfile: 'users/{userId}/profile',
    addResetPasswordCode: 'users/{userId}/add-reset-password-code',
    getRoles: 'users/{userId}/roles',
    assignRoleToUser: 'users/{userId}/roles',
    unassignRoleFromUser: 'users/{userId}/roles/{systemRoleId}',
    search: 'users/search',
    getMyMissionDevices: 'users/my-mission-devices',
    profileWithRoles: 'users/get-user-profile-roles'
  },
  roles: {
    getAll: 'roles',
    getAllByJobContext: 'roles/by-job-context',
    getAllOfTypeSystem: 'roles/of-type-system',
    create: 'roles',
    getIsRoleNameAvailable: 'roles/role-name-available/{roleName}',
    get: 'roles/{roleId}',
    update: 'roles/{roleId}',
    getPermissions: 'roles/{roleId}/permissions',
    addPermissionToRole: 'roles/{roleId}/permissions/{permissionId}',
    removePermissionFromRole: 'roles/{roleId}/permissions/{permissionId}',
    getUsersInRole: 'roles/{roleId}/users',
    delete: 'roles/{roleId}'
  },
  permissions: {
    getAll: 'permissions'
  },
  jobs: {
    search: 'jobs/search',
    create: 'jobs',
    getJob: 'jobs/{jobId}',
    updateJob: 'jobs/{jobId}',
    getJobVehicles: 'jobs/{jobId}/vehicles',
    getJobDevices: 'jobs/{jobId}/devices',
    getJobVehiclesWithDeviceAssignments: 'jobs/{jobId}/vehicles-with-device-assignments',
    getCurrentJobConfiguration: 'jobs/current-job-configuration',
    getJobListConfiguration: 'jobs/job-list-configuration',
    getJobDevicesWithCurrentVehicle: 'jobs/{jobId}/devices-with-current-vehicle',
    addDeviceToVehicleAssignment: 'jobs/device-to-vehicle-assignment',
    updateDeviceToVehicleAssignment: 'jobs/device-to-vehicle-assignment/{assignmentId}',
    deleteDeviceToVehicleAssignment: 'jobs/device-to-vehicle-assignment/{assignmentId}',
    addUserToJob: 'jobs/{jobId}/users',
    getJobUsers: 'jobs/{jobId}/users',
    removeJobUser: 'jobs/{jobId}/users/{userId}',
    archiveJob: 'jobs/{jobId}/archive',
    deleteJob: 'jobs/{jobId}',
    getJobLastArchivedAt: 'jobs/{jobId}/last-archived-at',
    getJobArchivesList: 'jobs/archives',
    deleteJobArchive: 'jobs/job-archives/{archiveId}',
    jobArchiveDownload: 'jobs/job-archives/{archiveId}/download',
    jobArchiveRestoreUrl: 'jobs/job-archives/{archiveId}/restore',
    jobArchiveUpload: 'jobs/job-archives/upload',
  },
  vehicles: {
    create: 'vehicles',
    update: 'vehicles'
  },
  devices: {
    create: 'devices',
    getAll: 'devices',
    get: 'devices/{deviceId}',
    update: 'devices/{deviceId}',
    getUsers: 'devices/{deviceId}/users',
    assignUser: 'devices/{deviceId}/users/{userId}/assign',
    unassignUser: 'devices/{deviceId}/users/{userId}',
    getIsPAIPAddressAvailable: 'devices/paip-address-available/{paipAddress}',
    search: 'devices/search',
    filter:'devices/get-filtered-device/{filter}'
  },
  deviceEvents: {
    search: 'device-events/search',
    acknowledge: 'device-events/{deviceEventId}/acknowledge',
    acknowledgeAll: 'device-events/acknowledge-all'
  },
  settings: {
    getAll: 'settings',
    update: 'settings'
  },
  connectionEvents: {
    getLastConnectionActivities: 'connection-events/last-connection-activities',
    getIPAddress: 'connection-events/ip-address'
  },
  deviceRecordsStatistics: {
    getDeviceRecordsCountWithMinMaxDates: 'device-records-statistics/records-count-with-min-and-max-dates',
    getDeviceRecordsCountWithMinMaxDatesForDatesInThePast: 'device-records-statistics/records-count-with-min-and-max-dates-for-dates-in-the-past',
    getDeviceRecordsCountWithMinMaxDatesForDatesInTheFuture: 'device-records-statistics/records-count-with-min-and-max-dates-for-dates-in-the-future'
  },
  apiRequests: {
    getLastApiUserActivities: 'api-requests/last-api-user-activities',
    getIPAddress: 'api-requests/ip-address'
  },
  serverInfo: {
    get: 'server-info'
  },
  clientSettings: {
    get: 'client-settings'
  },
  geocode: {
    reverse: 'geocode/reverse?lat={lat}&lon={lon}'
  },
  trackingServerDiagnostics: {
    search: 'tracking-server-diagnostics/search'
  },
  encryptionKeys: {
    get: 'encryption-keys',
    set: 'encryption-keys',
    uploadExportedData: 'encryption-keys/exported-data'
  },
  userProfileSettings: {
    get: 'user-profile-settings/{userId}',
    updateUserTable: 'user-profile-settings/update-user-table/{userId}',
    updateDeviceTable: 'user-profile-settings/update-device-table/{userId}',
    updateRoleTable: 'user-profile-settings/update-role-table/{userId}',
    updateMissionTable: 'user-profile-settings/update-mission-table/{userId}',
    updateAlarmNotifications: 'user-profile-settings/update-alarm-notifications/{userId}',
    updateMissionAnalysis: 'user-profile-settings/update-mission-analysis/{userId}',
    updateMissionPosition: 'user-profile-settings/update-mission-position/{userId}'
  },
};
